import { BiZoomIn } from 'react-icons/bi';
import Empty from '../empty/Empty';

const GalleryGroup = ({galleries, isSetObj, isSetModal}) => {

      if(galleries.data || galleries.length === 0){

            return <div className="group_gallery__img empty">
                  <Empty text="Oops! Images Not Fount." />
            </div>
      }

      const selectObj = (item) => {
            isSetObj(item);
            isSetModal(true);
      }

      return (
            <div className="group_gallery__img">
                  {
                        galleries?.map((item, index) => (
                              <div className="gallery_img_card" key={index}>
                                    <img src={item.image} alt={item.description} />
                                    <button className="btn_gallery__zoom" onClick={() => selectObj(item)}><BiZoomIn /></button>
                              </div>
                        ))
                  }
            </div>
      )
}

export default GalleryGroup;